import React from 'react';
import KnowledgeCategory from './Knowledge/Category';
import KnowledgeQuestion from './Knowledge/Question';
import KnowledgeQuestionStatistics from './Knowledge/Question/Statistics';
import Knowledge from './Knowledge/Knowledge';
import KnowledgeWords from './Knowledge/Word';
import KnowledgePeopleWords from './Knowledge/PeopleWord';
import KnowledgeLearn from './Knowledge/Learn';
import OrgStructure from './Org/Structure';
import OrgUser from './Org/User';
import HistoryAnswer from './History/Answer';
import HistoryQuestion from './History/Question';
import HistoryWords from './History/Words';
import HistoryUnknownQustion from './History/UnknownQuestion';
import HistorySpiderTask from './History/SpiderTask';
import Setting from './Setting';
import Spider from './Spider';
import Plugin from './Plugin';
import Layout from '../../components/Layout/Admin';

export default {
  chunks: ['admin'],
  path: '/admin',
  children: [
    {
      path: '',
      action() {
        return { redirect: '/admin/knowledge/question' };
      },
    },
    {
      path: '/home',
      action(context) {
        return {
          title: '报表统计',
          component: (
            <Layout {...context}>
              <div>
                <img src="/assets/images/dashboard.png" alt="" width="100%" />
              </div>
            </Layout>
          ),
        };
      },
    },
    {
      path: '/knowledge/category',
      action(context) {
        return {
          title: '知识分类',
          component: (
            <Layout {...context}>
              <KnowledgeCategory />
            </Layout>
          ),
        };
      },
    },
    {
      path: '/knowledge/question',
      action(context) {
        return {
          title: '问题管理',
          component: (
            <Layout {...context}>
              <KnowledgeQuestion />
            </Layout>
          ),
        };
      },
    },
    {
      path: '/statistics',
      action(context) {
        return {
          title: '数据统计',
          component: (
            <Layout {...context}>
              <KnowledgeQuestionStatistics />
            </Layout>
          ),
        };
      },
    },
    {
      path: '/knowledge/knowledge',
      action(context) {
        return {
          title: '知识点管理',
          component: (
            <Layout {...context}>
              <Knowledge />
            </Layout>
          ),
        };
      },
    },
    {
      path: '/knowledge/words',
      action(context) {
        return {
          title: '敏感词设置',
          component: (
            <Layout {...context}>
              <KnowledgeWords />
            </Layout>
          ),
        };
      },
    },
    {
      path: '/knowledge/people-words',
      action(context) {
        return {
          title: '百姓体词库',
          component: (
            <Layout {...context}>
              <KnowledgePeopleWords />
            </Layout>
          ),
        };
      },
    },
    {
      path: '/knowledge/learn',
      action(context) {
        return {
          title: '问题学习',
          component: (
            <Layout {...context}>
              <KnowledgeLearn />
            </Layout>
          ),
        };
      },
    },
    {
      path: '/org/structure',
      action(context) {
        return {
          title: '组织管理',
          component: (
            <Layout {...context}>
              <OrgStructure />
            </Layout>
          ),
        };
      },
    },
    {
      path: '/org/user',
      action(context) {
        return {
          title: '用户管理',
          component: (
            <Layout {...context}>
              <OrgUser />
            </Layout>
          ),
        };
      },
    },
    {
      path: '/history/question',
      action(context) {
        return {
          title: '问题操作日志',
          component: (
            <Layout {...context}>
              <HistoryQuestion />
            </Layout>
          ),
        };
      },
    },
    {
      path: '/history/answer',
      action(context) {
        return {
          title: '答案操作日志',
          component: (
            <Layout {...context}>
              <HistoryAnswer />
            </Layout>
          ),
        };
      },
    },
    {
      path: '/history/words',
      action(context) {
        return {
          title: '敏感词操作日志',
          component: (
            <Layout {...context}>
              <HistoryWords />
            </Layout>
          ),
        };
      },
    },
    {
      path: '/history/spider',
      action(context) {
        return {
          title: '数据采集操作日志',
          component: (
            <Layout {...context}>
              <HistorySpiderTask />
            </Layout>
          ),
        };
      },
    },
    {
      path: '/history/unknown_question',
      action(context) {
        return {
          title: '未知问题操作日志',
          component: (
            <Layout {...context}>
              <HistoryUnknownQustion />
            </Layout>
          ),
        };
      },
    },
    {
      path: '/spider',
      action(context) {
        return {
          title: '数据采集',
          component: (
            <Layout {...context}>
              <Spider />
            </Layout>
          ),
        };
      },
    },
    {
      path: '/setting',
      action(context) {
        return {
          title: '系统设置',
          component: (
            <Layout {...context}>
              <Setting />
            </Layout>
          ),
        };
      },
    },
    {
      path: '/plugin',
      action(context) {
        return {
          title: '插件管理',
          component: (
            <Layout {...context}>
              <Plugin />
            </Layout>
          ),
        };
      },
    },
  ],
};
